import { useState, useEffect, useCallback } from "react";
import * as Scrivito from "scrivito";
import { useAuthStore } from "stores/authStore";
import { useScrivitoObj } from "hooks/useScrivitoObj";

enum SUBTYPES {
  FIRE_PROTECTION_WIZARD = "fireprotection",
  ROOM_CONTROL_WIRED_WIZARD = "roomcontrol",
  ROOM_CONTROL_WIRELESS_WIZARD = "roomcontrolwireless",
  X_CUBE_WIZARD = "xcube",
  X_FANS_WIZARD = "xfans",
}

export const useEnabledWizardObjs = () => {
  const checkIsEnabled = useCheckIsWizardEnabled();
  const [wizardObjs, setWizardObjs] = useState<Scrivito.Obj[] | null>(null);
  const { obj: page, isLoading } = useScrivitoObj("WizardList");

  useEffect(() => {
    const handleSetWizardObjs = async () => {
      if (wizardObjs === null && page) {
        const wizardItems = (await Scrivito.load(() =>
          page?.get("wizardItem"),
        )) as Scrivito.Obj[];
        setWizardObjs(
          wizardItems.filter((wizardItem) => {
            const subType = wizardItem.get("subType") as SUBTYPES;
            return checkIsEnabled(subType);
          }) || [],
        );
      }
    };
    handleSetWizardObjs();
  }, [checkIsEnabled, page, wizardObjs]);

  return { wizardObjs, isLoading: isLoading || wizardObjs === null };
};

export const useCheckIsWizardEnabled = () => {
  const featureFlags = useAuthStore.use.featureFlags();
  const checkIsEnabled = useCallback(
    (subType: SUBTYPES) => {
      switch (subType) {
        case SUBTYPES.FIRE_PROTECTION_WIZARD:
          return featureFlags?.["FIRE_PROTECTION_WIZARD"];
        case SUBTYPES.ROOM_CONTROL_WIRED_WIZARD:
          return featureFlags?.["ROOM_CONTROL_WIRED_WIZARD"];
        case SUBTYPES.ROOM_CONTROL_WIRELESS_WIZARD:
          return featureFlags?.["ROOM_CONTROL_WIRELESS_WIZARD"];
        case SUBTYPES.X_CUBE_WIZARD:
          return featureFlags?.["X_CUBE_WIZARD"];
        case SUBTYPES.X_FANS_WIZARD:
          return featureFlags?.["X_FANS_WIZARD"];
        default:
          return false;
      }
    },
    [featureFlags],
  );

  return checkIsEnabled;
};
